import { NOISE_PNG } from "@/lib/noise-texture"

interface CRTOverlayProps {
  /** Overall intensity multiplier (0–1). Default 1. */
  intensity?: number
}

/**
 * CRT broadcast overlay package: TV banding, vignette, scanlines, and noise grain.
 * Must be placed inside a `position: relative` container that sets the overlay bounds.
 */
export function CRTOverlay({ intensity = 1 }: CRTOverlayProps) {
  return (
    <>
      {/* TV-banded texture */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            "repeating-linear-gradient(0deg, oklch(1 0 0 / 0.08) 0px, oklch(1 0 0 / 0.08) 1px, transparent 1px, transparent 4px)",
          opacity: intensity,
          zIndex: 0,
        }}
      />

      {/* Cinematic vignette */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          boxShadow:
            "inset 0 0 200px 60px oklch(0 0 0 / 0.5), inset 0 0 80px 20px oklch(0 0 0 / 0.3)",
          opacity: intensity,
          zIndex: 1,
        }}
      />

      {/* CRT scanlines */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            "repeating-linear-gradient(0deg, transparent, transparent 3px, oklch(0 0 0 / 0.03) 3px, oklch(0 0 0 / 0.03) 6px)",
          opacity: intensity,
          zIndex: 2,
        }}
      />

      {/* Noise grain */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage: `url("${NOISE_PNG}")`,
          backgroundRepeat: "repeat",
          opacity: 0.06 * intensity,
          zIndex: 2,
        }}
      />
    </>
  )
}
